// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invIntakeDraftId } from './InvIntakeDraft';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const invIntakeDraftImageId = (z.number());
export const invIntakeDraftImage = z.object({
    id: invIntakeDraftImageId,
    draft_id: invIntakeDraftId,
    file_storage_id: fileStorageId,
    display_order: z.number(),
    created_at: z.date(),
    detected_gtin: z.string().nullable(),
});
export const invIntakeDraftImageInitializer = z.object({
    id: invIntakeDraftImageId.optional(),
    draft_id: invIntakeDraftId,
    file_storage_id: fileStorageId,
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    detected_gtin: z.string().optional().nullable(),
});
export const invIntakeDraftImageMutator = z.object({
    id: invIntakeDraftImageId.optional(),
    draft_id: invIntakeDraftId.optional(),
    file_storage_id: fileStorageId.optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    detected_gtin: z.string().optional().nullable(),
});
//# sourceMappingURL=InvIntakeDraftImage.js.map